import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

/**
 * Router context injected at `createRouter` time and refreshed live via
 * `<RouterProvider context={{ auth }} />` (see main.tsx). The `_authenticated`
 * layout reads `context.auth.isSignedIn` in its `beforeLoad` guard.
 */
export interface RouterContext {
  auth: {
    isSignedIn: boolean;
  };
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return <Outlet />;
}
